import { render, staticRenderFns } from "./TEXTDISPLAY.vue?vue&type=template&id=7e1d6748&scoped=true&"
import script from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
export * from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
import style0 from "./TEXTDISPLAY.vue?vue&type=style&index=0&id=7e1d6748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1d6748",
  null
  
)

export default component.exports